$(function() {
    $('.js-remove-it').on('click', function removeFilter() {
        $(this).remove();
    });

    $('.js-remove-all').on('click', function removeAllFilters() {
        $('.js-remove-it').remove();
        $(this).remove();
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/category/clear-filter.js